import React from 'react';
import { Box, Typography, Grid, Divider, Card, CardContent, Container, Chip, Stack } from '@mui/material';

import Page from './Page';
import Header from './Header';

const About = () => {
  const pillars = [
    {
      title: 'Craftsmanship',
      description: 'We source heavyweight textiles, reinforce edges and use vivid fade-resistant inks so your rented cloths look incredible even after multiple events.'
    },
    {
      title: 'Reliability',
      description: 'Orders ship from our Atlanta fulfillment center with proactive tracking updates, weekend support and guaranteed arrival windows.'
    },
    {
      title: 'Sustainability',
      description: 'Renting keeps specialty gaming décor in circulation and out of storage closets. We launder with eco-certified detergents and recycle shipping materials.'
    }
  ];

  return (
    <Page sx={{ background: '#fff' }}>
      <Container maxWidth="lg">
        <Chip label="Family-Owned & Operated" color="secondary" sx={{ mb: 2 }} />
        <Header text="Our Story" subHeader="Helping hosts create casino nights without the full casino price tag" />
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="body1" sx={{ mb: 3 }}>
              DIY Casino Party was founded by event stylists who wanted casino-grade presentations without the cost or logistics of renting full tables. We built a rental-only model that lets hosts transform any dining room or conference space using lightweight cloths that ship affordably and store easily.
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Today we support corporate teams, nonprofits, wedding planners and families who want the casino look with a DIY budget. Every cloth is inspected, steamed and rolled by hand before it leaves our studio, and our support team is on standby from the moment you reserve until the cloth returns to us.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack spacing={2}>
              <Card sx={{ borderLeft: '4px solid #d28b21' }}>
                <CardContent>
                  <Typography variant="h4">Mission</Typography>
                  <Typography variant="body2">Deliver casino-caliber details without the storage or staffing headaches of traditional rentals.</Typography>
                </CardContent>
              </Card>
              <Card sx={{ borderLeft: '4px solid #003a27' }}>
                <CardContent>
                  <Typography variant="h4">Coverage</Typography>
                  <Typography variant="body2">Nationwide shipping from our Atlanta fulfillment studio with concierge support and proactive tracking.</Typography>
                </CardContent>
              </Card>
            </Stack>
          </Grid>
        </Grid>
        <Grid container spacing={3} sx={{ my: 4 }}>
          {pillars.map(pillar => (
            <Grid key={pillar.title} item xs={12} md={4}>
              <Card sx={{ height: '100%', boxShadow: '0 20px 45px rgba(0,0,0,0.08)' }}>
                <CardContent>
                  <Typography variant="h4">{pillar.title}</Typography>
                  <Divider sx={{ my: 1 }} />
                  <Typography variant="body2">{pillar.description}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Box>
          <Typography variant="h3" gutterBottom>
            Behind the Scenes
          </Typography>
          <Typography variant="body1">
            We are designers, logistics specialists and casino superfans headquartered in Atlanta with satellite support staff across the country. When you rent from DIY Casino Party you get an approachable team that cares about every shipment and every return. We are continually expanding our library of artwork and layouts—let us know if there is a look you want to offer your guests without renting full tables.
          </Typography>
        </Box>
      </Container>
    </Page>
  );
};

export default About;
